export default "__VITE_ASSET__ca74ed2e__"